import { autoserialize, autoserializeAs } from 'cerialize';
import { OrganizationServiceLevel } from './organization-service-level';

export class OrganizationInfo {
  @autoserialize
  id: number;

  @autoserialize
  name: string;

  @autoserialize
  code: string;

  @autoserialize
  bookingPhoneNumber: string;

  @autoserialize
  riderEligibilityPhoneNumber: string;

  @autoserialize
  riderAppEnabled: boolean;

  @autoserialize
  riderAppItineraryCreationEnabled: boolean;

  @autoserialize
  riderPaymentRequired: boolean;

  @autoserialize
  riderPaymentAccountEnabled: boolean;

  @autoserialize
  riderFareCollectionEnabled: boolean;

  @autoserializeAs(OrganizationServiceLevel)
  organizationServiceLevels: Array<OrganizationServiceLevel>;

  @autoserialize
  delayPickUpAllowed: boolean;

  @autoserialize
  riderSelfServiceRideCancelAllowed: boolean;
}
